<template>
	<v-container fluid fill-height fill-width grid-list-xl>
		<v-layout row wrap>
			<v-checkbox v-if="somePlansHaveYearlyPricing" v-model="isShowingYearly" label="Show yearly pricing options" class="billing-cycle-toggle mt-1"></v-checkbox>
			<div id="plan-container">
				<v-layout row wrap>
					<v-flex md4 sm6 v-for="productPlan in productPlans" :key="productPlan.id" >
						<ProductPlanDetails :product-plan="productPlan" :yearly="isShowingYearly" @select="selectPlan" />
					</v-flex>
				</v-layout>
			</div>
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	import ProductPlanDetails from '@components/settings/billing/ProductPlanDetails.vue';
	import ProductPlanBillingCycle from '@/enums/productPlanBillingCycle';

	export default {
		components: { ProductPlanDetails },
		data() {
			return {
				isShowingYearly: false
			};
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				productPlans: 'productPlans/productPlansLeastToMostExpensive'
			}),
			somePlansHaveYearlyPricing() {
				return this.productPlans.some(x => {
					return x.pricingOptions.some(y => y.billingCycle === ProductPlanBillingCycle.Annual);
				});
			}
		},
		methods: {
			selectPlan(planAndPricingOptionIds) {
				const planAndPricingId = {
					plan: this.productPlans.find(x => x.id === planAndPricingOptionIds.planId),
					pricingId: planAndPricingOptionIds.pricingId
				};
				this.$emit('selectPlan', planAndPricingId);
			}
		}
	};
</script>

<style scoped>
	#plan-container {
		padding: 0.5rem;
		width: 100%;
		display: flex;
		justify-content: space-between;
		gap: 1rem;
		overflow-x: scroll;
		-ms-overflow-style: none; /* IE and Edge */
		scrollbar-width: none; /* Firefox */
	}
	#plan-container::-webkit-scrollbar {
		display: none;
	}

	#selector-header {
		display: flex;
		flex-direction: column;
		align-content: center;
		align-items: center;
	}
</style>
